var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm.item.dl == "0" && _vm.item.status == "1" && _vm.item.payment_id == 0
        ? _c("div", { staticClass: "container mb-5 pb-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("div", { staticClass: "col-md-12  text-left" }, [
                _c("h3", { staticClass: "Regular h0 widthFull" }, [
                  _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code) + " ")])
                ])
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-6 center mb-3 vaillantCont text-center pt-5 pb-5"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.changeDL("old")
                        }
                      }
                    },
                    [
                      _c("h5", { staticClass: "white" }, [
                        _vm._v("\n\n            Confermo che:\n            "),
                        _c("br"),
                        _vm._v(
                          "- Copia di cortesia o Fattura trasmessa al Sistema di Interscambio (Sdi) dal professionista\n            aderente " +
                            _vm._s(_vm.brand) +
                            " verso il proprio cliente (committente) con Data Documento "
                        ),
                        _c("b", { staticClass: "black Bold uppercase" }, [
                          _vm._v(" entro ")
                        ]),
                        _vm._v(
                          " l’11\n            novembre 2021 (incluso)\n            "
                        ),
                        _c("br"),
                        _vm._v(
                          "− Data di esecuzione del Bonifico Bancario (parlante) disposto dal cliente (committente)\n            "
                        ),
                        _c("b", { staticClass: "black Bold uppercase" }, [
                          _vm._v(" entro ")
                        ]),
                        _vm._v(
                          ", l’11 novembre 2021 (incluso), in riferimento alla relativa fattura rilasciata dal\n            professionista aderente CheBonus\n            "
                        ),
                        _c("br")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-6 center mb-3 vaillantCont text-left pt-5 pb-5"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.changeDL("new")
                        }
                      }
                    },
                    [
                      _c("h5", { staticClass: "white" }, [
                        _vm._v("\n          Confermo che:\n          "),
                        _c("br"),
                        _vm._v(
                          "- Copia di cortesia o Fattura trasmessa al Sistema di Interscambio (Sdi) dal professionista\n          aderente " +
                            _vm._s(_vm.brand) +
                            " verso il proprio cliente (committente) con Data Documento "
                        ),
                        _c("b", { staticClass: "black Bold uppercase" }, [
                          _vm._v(" oltre ")
                        ]),
                        _vm._v(
                          " l’11\n          novembre 2021 (incluso)\n          "
                        ),
                        _c("br"),
                        _vm._v(
                          "− Data di esecuzione del Bonifico Bancario (parlante) disposto dal cliente (committente)\n          "
                        ),
                        _c("b", { staticClass: "black Bold uppercase" }, [
                          _vm._v(" oltre ")
                        ]),
                        _vm._v(
                          ", l’11 novembre 2021 (incluso) in riferimento alla relativa fattura rilasciata dal\n          professionista aderente CheBonus\n          "
                        ),
                        _c("br")
                      ])
                    ]
                  )
                ]
              )
            ])
          ])
        : _vm.item.dl == "0" &&
          _vm.item.status == "1" &&
          _vm.item.payment_id != 0 &&
          _vm.item.payment_id != "0" &&
          _vm.item.aditional_payment == 0
        ? _c("div", { staticClass: "container mb-5 pb-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("div", { staticClass: "col-md-12  text-left" }, [
                _c("h3", { staticClass: "Regular h0 widthFull" }, [
                  _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code) + " ")])
                ])
              ]),
              _vm._v(" "),
              _vm._m(2)
            ]),
            _vm._v(" "),
            !_vm.additionalPayment
              ? _c(
                  "div",
                  { staticClass: "row justify-content-center text-left" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-5 center mb-0 vaillantCont text-center pb-5"
                      },
                      [
                        _c(
                          "h4",
                          {
                            staticClass:
                              "Regular text-center h0 widthFull mt-5 "
                          },
                          [
                            _c("b", [
                              _vm._v(
                                "\n        Per completare la tua pratica a norma del D.L 157, bisogna integrare il visto di conformità\n          "
                              ),
                              _vm.item.flow == "poste"
                                ? _c("span", [_vm._v(" e la Due Diligence. ")])
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary mt-5 mb-5",
                            on: {
                              click: function($event) {
                                _vm.additionalPayment = true
                              }
                            }
                          },
                          [_vm._v("\n\n            Avanti\n\n          ")]
                        )
                      ]
                    )
                  ]
                )
              : _c(
                  "div",
                  { staticClass: "row justify-content-center text-left" },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-12 center mb-0 vaillantCont text-left"
                      },
                      [
                        !_vm.paySuccess
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "row justify-content-center text-left"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-8 center mb-3 text-left"
                                  },
                                  [
                                    _c(
                                      "h4",
                                      {
                                        staticClass:
                                          "Regular text-left h0 widthFull "
                                      },
                                      [
                                        _c("b", [
                                          _vm._v(
                                            " Per completare la tua pratica a norma del D.L 157, bisogna integrare il visto di conformità\n              "
                                          ),
                                          _vm.item.flow == "poste"
                                            ? _c("span", [
                                                _vm._v(" e la Due Diligence. ")
                                              ])
                                            : _vm._e(),
                                          _vm._v("\n               Acquista  "),
                                          _vm.item.flow == "poste"
                                            ? _c("span", [_vm._v("i servizi ")])
                                            : _c("span", [
                                                _vm._v("il servizio ")
                                              ]),
                                          _vm._v(
                                            " con una Carta, PayPal o Bonifico Bancario (SOFORT)\n\n            "
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "black mt-0 text-left widthFull "
                                      },
                                      [
                                        _vm._v(
                                          "\n              Il prezzo è riferito ad una pratica. A pagamento avvenuto potrai caricare i documenti richiesti e completare la pratica.\n            "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-4 pt-md-4 center mb-3 text-right"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-primary btnRed m-2 btn-sm ml-md-5 white",
                                        on: {
                                          click: function($event) {
                                            _vm.additionalPayment = false
                                          }
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: "arrow-left",
                                            size: "1x"
                                          }
                                        }),
                                        _vm._v(
                                          "\n              Indietro\n            "
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "row justify-content-center text-left"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-md-12 pb-0 buyPlan center" },
                              [
                                _c("h3", {
                                  staticClass: "center darkBlue mb-3"
                                }),
                                _vm._v(" "),
                                !_vm.paySuccess
                                  ? _c("div", { staticClass: "widthFull" }, [
                                      _c("div", { staticClass: "row " }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-sm-6 col-md-6 col-lg-6 text-left bgWhite"
                                          },
                                          [
                                            _c("div", { staticClass: "row " }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-8 text-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        " text-left mb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Costo aggiuntivo "
                                                      ),
                                                      _vm.item.flow == "poste"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              " di Due Diligence "
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(
                                                        " Servizio/Pratica (IVA Esclusa) "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-right"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        " text-right mb-0"
                                                    },
                                                    [
                                                      _c("b", {}, [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              _vm.buyPlan2.price
                                                            )
                                                          ) + " € "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "row " }, [
                                              _vm._m(4),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-right"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        " text-right mb-0"
                                                    },
                                                    [
                                                      _c("b", {}, [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              _vm.buyPlan2.visto
                                                            )
                                                          ) + " € "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.discountValue
                                              ? _c(
                                                  "div",
                                                  { staticClass: "row " },
                                                  [
                                                    _vm._m(5),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-md-3 text-right"
                                                      },
                                                      [
                                                        _c(
                                                          "h5",
                                                          {
                                                            staticClass:
                                                              " text-right mb-0 red"
                                                          },
                                                          [
                                                            _c("b", {}, [
                                                              _vm._v(
                                                                "- " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatNumber"
                                                                    )(
                                                                      _vm.discountValue
                                                                    )
                                                                  ) +
                                                                  " € "
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "row " }, [
                                              _vm._m(6),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-right"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        " text-right mb-4"
                                                    },
                                                    [
                                                      _c("b", {}, [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(_vm.buyPlan2.iva)
                                                          ) + " € "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "row " }, [
                                              _vm._m(7),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-right borderTopBlack"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        " text-right mb-4"
                                                    },
                                                    [
                                                      _c("b", {}, [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              _vm.buyPlan2
                                                                .amount
                                                            )
                                                          ) + " € "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "col-sm-0 col-md-1 col-lg-1 text-left"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-sm-6 col-md-6 col-lg-4"
                                          },
                                          [
                                            _vm.paypalOn
                                              ? _c(
                                                  "h2",
                                                  {
                                                    staticClass:
                                                      "center widthFull mb-3 mt-3 bgWhite pb-3"
                                                  },
                                                  [
                                                    _vm._m(8),
                                                    _vm._v(" "),
                                                    _c("paypalPayment", {
                                                      attrs: {
                                                        amount:
                                                          "" +
                                                          _vm.buyPlan2.amount,
                                                        "invoice-number":
                                                          _vm.brand +
                                                          "_DL_PRATICA_" +
                                                          _vm.item.code +
                                                          _vm.paypalDiscountString,
                                                        items: [
                                                          {
                                                            name:
                                                              _vm.brand +
                                                              "-" +
                                                              _vm.item.code,
                                                            description:
                                                              "PRATICA_" +
                                                              _vm.item.code,
                                                            price:
                                                              "" +
                                                              _vm.buyPlan2
                                                                .amount,
                                                            quantity: "1",
                                                            currency: "EUR"
                                                          }
                                                        ],
                                                        currency: "EUR",
                                                        locale: "it_IT",
                                                        experience:
                                                          _vm.experienceOptions,
                                                        practice: _vm.item.code,
                                                        dl: _vm.item.dl,
                                                        flow: _vm.item.flow,
                                                        userToken:
                                                          _vm.getProfile
                                                            .userToken,
                                                        PaypalOn: _vm.paypalOn,
                                                        sepaOn: _vm.sepaOn
                                                      },
                                                      on: {
                                                        paymentPPSuccess:
                                                          _vm.paymentPPSuccess
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.paySuccess
                                  ? _c(
                                      "div",
                                      { staticClass: "col-sm-12 center pb-5" },
                                      [
                                        _c("img", {
                                          staticClass: "img-fluid payImage",
                                          attrs: {
                                            src: require("../../assets/images/success.png")
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c("h1", { staticClass: "center" }, [
                                          _vm._v("Grazie per averci scelto, ")
                                        ]),
                                        _vm._v(" "),
                                        _c("h3", { staticClass: "center" }, [
                                          _vm._v(
                                            "il tuo pagamento è avvenuto con successo"
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary rn-btn-dark btnRed mt-5",
                                            on: {
                                              click: function($event) {
                                                _vm.payment = true
                                                _vm.item.aditional_payment = 1
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "hover hover-1" },
                                              [_vm._v("Procedi")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
          ])
        : !_vm.payment && _vm.loaded
        ? _c("div", { staticClass: "container mb-5 pb-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("h3", { staticClass: "Regular text-left h0 widthFull" }, [
                _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code) + " ")])
              ]),
              _vm._v(" "),
              _vm._m(9),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4 pt-md-4 center mb-3 text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary btnRed m-2 btn-sm ml-md-5",
                      attrs: { to: { name: "pratiche" } }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "arrow-left", size: "1x" }
                      }),
                      _vm._v("\n          Indietro\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("div", { staticClass: "col-md-12 pb-0 buyPlan center" }, [
                _c("h3", { staticClass: "center darkBlue mb-3" }),
                _vm._v(" "),
                !_vm.paySuccess
                  ? _c("div", { staticClass: "widthFull" }, [
                      _c("div", { staticClass: "row " }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-6 col-md-6 col-lg-6 text-left bgWhite"
                          },
                          [
                            _c("div", { staticClass: "row " }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 text-left customAccordion mb-3"
                                },
                                [
                                  _c(
                                    "badger-accordion",
                                    {
                                      key: "1232323",
                                      attrs: { icons: _vm.icons }
                                    },
                                    [
                                      _c(
                                        "badger-accordion-item",
                                        [
                                          _c(
                                            "template",
                                            {
                                              staticClass: "center",
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "h4",
                                                { staticClass: "Bold" },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      icon: "gift",
                                                      size: "md"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    " Hai un codice sconto ?\n                        "
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "black mt-0 text-left widthFull "
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          Se possiedi un codice sconto, potrai utilizzarlo per il pagamento\n                        "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "template",
                                            {
                                              staticClass: "bbaLightColor",
                                              slot: "content"
                                            },
                                            [
                                              _vm.discountError
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "widthFull Bold text-center red"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          Codice sconto non valido\n                        "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "form",
                                                {
                                                  staticClass: "widthFull",
                                                  attrs: {
                                                    id: "discount-form"
                                                  },
                                                  on: {
                                                    submit: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.checkDiscount(
                                                        $event
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-row justify-content-center"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-8 mb-1"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "group custInput"
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.discount,
                                                                    expression:
                                                                      "discount"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate",
                                                                    value: {
                                                                      required: true,
                                                                      max: 26,
                                                                      min: 5
                                                                    },
                                                                    expression:
                                                                      "{required:true, max: 26, min: 5}"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control",
                                                                class: {
                                                                  "is-invalid": _vm.errors.has(
                                                                    "discount"
                                                                  ),
                                                                  valid: !!_vm.discount
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  id:
                                                                    "discount",
                                                                  name:
                                                                    "discount",
                                                                  "data-vv-as":
                                                                    "Codice sconto"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.discount
                                                                },
                                                                on: {
                                                                  input: function(
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.discount =
                                                                      $event.target.value
                                                                  }
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c("span", {
                                                                staticClass:
                                                                  "highlight"
                                                              }),
                                                              _vm._v(" "),
                                                              _c("span", {
                                                                staticClass:
                                                                  "bar"
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "niceInputLabel",
                                                                  attrs: {
                                                                    for:
                                                                      "discount"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Codice Sconto"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.errors.has(
                                                                "discount"
                                                              )
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "invalid-feedback"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                  " +
                                                                          _vm._s(
                                                                            _vm.errors.first(
                                                                              "discount"
                                                                            )
                                                                          ) +
                                                                          "\n                                "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-4 mb-1 pt-3 text-center"
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-primary btn-sm btnYellow shadow mb-4 mt-4",
                                                              attrs: {
                                                                type: "submit"
                                                              }
                                                            },
                                                            [_vm._v("Applica")]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row " }, [
                              _vm._m(10),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-3 text-right" },
                                [
                                  _c(
                                    "h5",
                                    { staticClass: " text-right mb-0" },
                                    [
                                      _c("b", {}, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              _vm.buyPlan.price
                                            )
                                          ) + " € "
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.item.dl == "new"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(11),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-0" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.visto
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.discountValue
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(12),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-0 red" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              "- " +
                                                _vm._s(
                                                  _vm._f("formatNumber")(
                                                    _vm.discountValue
                                                  )
                                                ) +
                                                " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "row " }, [
                              _vm._m(13),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-3 text-right" },
                                [
                                  _c(
                                    "h5",
                                    { staticClass: " text-right mb-4" },
                                    [
                                      _c("b", {}, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              _vm.buyPlan.iva
                                            )
                                          ) + " € "
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.item.enea_request != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(14),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-0" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.priceEnea
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.enea_request != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(15),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-4" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.ivaEnea
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.to_get_cadastral_data != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(16),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-0" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.priceDcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.to_get_cadastral_data != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(17),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-4" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.ivaDcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "row " }, [
                              _vm._m(18),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-3 text-right borderTopBlack"
                                },
                                [
                                  _c(
                                    "h5",
                                    { staticClass: " text-right mb-4" },
                                    [
                                      _vm.item.enea_request == "0" &&
                                      _vm.item.to_get_cadastral_data == "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.item.enea_request != "0" &&
                                      _vm.item.to_get_cadastral_data == "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount_enea
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.item.enea_request == "0" &&
                                      _vm.item.to_get_cadastral_data != "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount_dcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.item.enea_request != "0" &&
                                      _vm.item.to_get_cadastral_data != "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount_enea_dcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "col-sm-0 col-md-1 col-lg-1 text-left"
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-6 col-md-6 col-lg-4" },
                          [
                            _vm.paypalOn
                              ? _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "center widthFull mb-3 mt-0 bgWhite pb-3"
                                  },
                                  [
                                    _vm._m(19),
                                    _vm._v(" "),
                                    _vm.item.enea_request == "0" &&
                                    _vm.item.to_get_cadastral_data == "0"
                                      ? _c("paypalPayment", {
                                          attrs: {
                                            amount: "" + _vm.buyPlan.amount,
                                            "invoice-number":
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code +
                                              _vm.paypalDiscountString,
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            currency: "EUR",
                                            locale: "it_IT",
                                            experience: _vm.experienceOptions,
                                            practice: _vm.item.code,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            sepaOn: _vm.sepaOn
                                          },
                                          on: {
                                            paymentPPSuccess:
                                              _vm.paymentPPSuccess
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.item.enea_request != "0" &&
                                    _vm.item.to_get_cadastral_data == "0"
                                      ? _c("paypalPayment", {
                                          attrs: {
                                            amount:
                                              "" + _vm.buyPlan.amount_enea,
                                            "invoice-number":
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code +
                                              _vm.paypalDiscountString,
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Pratica ENEA",
                                                description:
                                                  "Servizio di redazione e invio pratica ENEA",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceEnea * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            currency: "EUR",
                                            locale: "it_IT",
                                            experience: _vm.experienceOptions,
                                            practice: _vm.item.code,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            sepaOn: _vm.sepaOn
                                          },
                                          on: {
                                            paymentPPSuccess:
                                              _vm.paymentPPSuccess
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.item.enea_request == "0" &&
                                    _vm.item.to_get_cadastral_data != "0"
                                      ? _c("paypalPayment", {
                                          attrs: {
                                            amount:
                                              "" + _vm.buyPlan.amount_dcast,
                                            "invoice-number":
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code +
                                              _vm.paypalDiscountString,
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Visura Catastale",
                                                description:
                                                  "Servizio Visura Catastale",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceDcast * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            currency: "EUR",
                                            locale: "it_IT",
                                            experience: _vm.experienceOptions,
                                            practice: _vm.item.code,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            sepaOn: _vm.sepaOn
                                          },
                                          on: {
                                            paymentPPSuccess:
                                              _vm.paymentPPSuccess
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.item.enea_request != "0" &&
                                    _vm.item.to_get_cadastral_data != "0"
                                      ? _c("paypalPayment", {
                                          attrs: {
                                            amount:
                                              "" +
                                              _vm.buyPlan.amount_enea_dcast,
                                            "invoice-number":
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code +
                                              _vm.paypalDiscountString,
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Pratica ENEA",
                                                description:
                                                  "Servizio di redazione e invio pratica ENEA",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceEnea * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Visura Catastale",
                                                description:
                                                  "Servizio Visura Catastale",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceDcast * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            currency: "EUR",
                                            locale: "it_IT",
                                            experience: _vm.experienceOptions,
                                            practice: _vm.item.code,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            sepaOn: _vm.sepaOn
                                          },
                                          on: {
                                            paymentPPSuccess:
                                              _vm.paymentPPSuccess
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.autoReNew && !_vm.loadButtons
                                      ? _c("div", {
                                          attrs: {
                                            id: "paypal-button-container"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            2 == 3
                              ? _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "center widthFull mb-3 mt-3 bgWhite"
                                  },
                                  [
                                    _vm.item.enea_request == "0" &&
                                    _vm.item.to_get_cadastral_data == "0"
                                      ? _c("stripePayment", {
                                          attrs: {
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            invoiceNumber:
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code,
                                            amount: "" + _vm.buyPlan.amount,
                                            practice: _vm.item.code,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            sepaOn: _vm.sepaOn,
                                            discount: _vm.discount,
                                            discountValue: _vm.discountValue
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.item.enea_request != "0" &&
                                    _vm.item.to_get_cadastral_data == "0"
                                      ? _c("stripePayment", {
                                          attrs: {
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Pratica ENEA",
                                                description:
                                                  "Servizio di redazione e invio pratica ENEA",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceEnea * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            amount:
                                              "" + _vm.buyPlan.amount_enea,
                                            invoiceNumber:
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code,
                                            practice: _vm.item.code,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            sepaOn: _vm.sepaOn,
                                            discount: _vm.discount,
                                            discountValue: _vm.discountValue
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.item.enea_request == "0" &&
                                    _vm.item.to_get_cadastral_data != "0"
                                      ? _c("stripePayment", {
                                          attrs: {
                                            amount:
                                              "" + _vm.buyPlan.amount_dcast,
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Visura Catastale",
                                                description:
                                                  "Servizio Visura Catastale",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceDcast * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            invoiceNumber:
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code,
                                            practice: _vm.item.code,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            sepaOn: _vm.sepaOn,
                                            discount: _vm.discount,
                                            discountValue: _vm.discountValue
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.item.enea_request != "0" &&
                                    _vm.item.to_get_cadastral_data != "0"
                                      ? _c("stripePayment", {
                                          attrs: {
                                            amount:
                                              "" +
                                              _vm.buyPlan.amount_enea_dcast,
                                            "invoice-number":
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code,
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Pratica ENEA",
                                                description:
                                                  "Servizio di redazione e invio pratica ENEA",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceEnea * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Visura Catastale",
                                                description:
                                                  "Servizio Visura Catastale",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceDcast * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            invoiceNumber:
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code,
                                            practice: _vm.item.code,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            sepaOn: _vm.sepaOn,
                                            discount: _vm.discount,
                                            discountValue: _vm.discountValue
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.paySuccess
                  ? _c("div", { staticClass: "col-sm-12 center" }, [
                      _c("img", {
                        staticClass: "img-fluid payImage",
                        attrs: {
                          src: require("../../assets/images/success.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("h1", { staticClass: "center" }, [
                        _vm._v("Grazie per averci scelto, ")
                      ]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "center" }, [
                        _vm._v("il tuo pagamento è avvenuto con successo")
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary rn-btn-dark btnRed mt-5",
                          on: {
                            click: function($event) {
                              _vm.payment = true
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "hover hover-1" }, [
                            _vm._v("Procedi")
                          ])
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        : _vm.payment && _vm.loaded
        ? _c("div", { staticClass: "container  mb-5 pb-5 pt-2" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("div", { staticClass: "col-md-12  text-left" }, [
                _c("h3", { staticClass: "Regular h0 widthFull" }, [
                  _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code) + " ")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-8 center mb-3 text-left" }, [
                _vm._m(20),
                _vm._v(" "),
                _c("p", { staticClass: "black mt-0 text-left widthFull " }, [
                  _vm._v(
                    "\n          Prepara e carica tutti i documenti richiesti. Al termine dell caricamento ogni singolo documento clicca su pulsante CONCLUDI.\n        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "black mt-0 text-left widthFull " },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "mr-2",
                      attrs: { icon: "star-of-life", size: "" }
                    }),
                    _vm._v(" "),
                    _c("b", [_vm._v("Documenti Obbligatori")])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4 pt-md-4 center mb-3 text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary btnRed m-2 btn-sm ml-md-5",
                      attrs: { to: { name: "pratiche" } }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "arrow-left", size: "1x" }
                      }),
                      _vm._v("\n          Indietro\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass:
                  "pb-5 mb-5 black pt-2 pl-4 pr-4 widthFull vaillantCont",
                attrs: { id: "doc-form" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "row  pt-2 mb-3",
                    staticStyle: {
                      "border-bottom": "1px solid grey",
                      "padding-bottom": "0!important"
                    }
                  },
                  [
                    _vm._m(21),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md-5 bordered text-center text-md-center"
                      },
                      [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "widthFull black mt-0 pt-0 docTitleMob pl-md-3"
                          },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "mandatoryDoc",
                              staticStyle: { opacity: "0" },
                              attrs: { icon: "star-of-life", size: "xs" }
                            }),
                            _vm._v(" "),
                            _c("small", [_vm._v("Documento")])
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(22),
                    _vm._v(" "),
                    _vm._m(23),
                    _vm._v(" "),
                    _vm._m(24),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-21 col-md-1 center bordered tablePdMob"
                      },
                      [_vm._v("\n            Caricamento Concluso\n          ")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.documents, function(doc, index, k) {
                  return (doc.codice != "2050D11" ||
                    (_vm.item.dcast_export == "10" &&
                      doc.codice == "2050D11") ||
                    (_vm.item.to_get_cadastral_data == "0" &&
                      doc.codice == "2050D11")) &&
                    (doc.codice != "2050D15" ||
                      (_vm.item.enea_pdf && doc.codice == "2050D15") ||
                      (_vm.item.enea_request == "0" && doc.codice == "2050D15"))
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "row justify-content-center vaillantCont pt-2 pb-2",
                          class: {
                            "pt-0": k == 0,
                            even: String(k / 2).includes(".")
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-1 bordered center tablePdMob"
                            },
                            [
                              doc.mandatory == "no" && doc.codice == "2050D0B"
                                ? [
                                    !_vm.uploadFrontPercentage[index][
                                      "countImages"
                                    ] ||
                                    _vm.uploadFrontPercentage[index][
                                      "hasError"
                                    ] == "yes"
                                      ? _c("img", {
                                          staticClass:
                                            "img-fluid widthFull maxBomTr",
                                          attrs: {
                                            src: require("../../assets/images/traficLight_green.png")
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                : [
                                    !_vm.uploadFrontPercentage[index][
                                      "countImages"
                                    ] ||
                                    _vm.uploadFrontPercentage[index][
                                      "hasError"
                                    ] == "yes"
                                      ? _c("img", {
                                          staticClass:
                                            "img-fluid widthFull maxBomTr",
                                          attrs: {
                                            src: require("../../assets/images/traficLight_red.png")
                                          }
                                        })
                                      : _vm._e()
                                  ],
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["countImages"] &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: require("../../assets/images/traficLight_yellow.png")
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: require("../../assets/images/traficLight_green.png")
                                    }
                                  })
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-5 bordered text-center text-md-left"
                            },
                            [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "widthFull black mt-0 pt-0 docTitleMob pl-md-3"
                                },
                                [
                                  doc.mandatory == "yes"
                                    ? _c("font-awesome-icon", {
                                        staticClass: "mandatoryDoc",
                                        attrs: {
                                          icon: "star-of-life",
                                          size: "xs"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.item.flow == "agileenergy" &&
                                  doc.codice == "2050D06E"
                                    ? [
                                        _vm._v(
                                          " Contratto per la fornitura e l’installazione accettato e firmato dal cliente "
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.item.flow == "agileenergy" &&
                                  doc.codice == "2050D07A"
                                    ? [
                                        _vm._v(
                                          " Evidenze di pagamento da parte del Cliente Finale (bonifico ordinario)"
                                        )
                                      ]
                                    : [_vm._v(" " + _vm._s(doc.name) + " ")],
                                  _vm._v(" "),
                                  doc.codice == "2050D01" ||
                                  doc.codice == "2050D02" ||
                                  doc.codice == "2050D03"
                                    ? _c("span", [_c("br"), _vm._m(25, true)])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.uploadFrontPercentage[index][
                                    "hasError"
                                  ] == "yes"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "widthFull red mt-0 pt-0 docTitleMob pl-md-3"
                                        },
                                        [
                                          _vm._v(
                                            "\n              Rilevata la seguente anomalia: "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(
                                              _vm.uploadFrontPercentage[index][
                                                "error"
                                              ]
                                            ) + "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.errors.has("fileInput" + index)
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback-custom" },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "fileInput" + index
                                            )
                                          ) +
                                          "\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["percent"]
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "progress",
                                      attrs: { id: "progFront" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "progress-bar",
                                          style: {
                                            width:
                                              _vm.uploadFrontPercentage[index][
                                                "percent"
                                              ] + "%"
                                          },
                                          attrs: {
                                            id: "progress-bar-front",
                                            role: "progressbar",
                                            "aria-valuenow": "50",
                                            "aria-valuemin": "0",
                                            "aria-valuemax": "100"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.uploadFrontPercentage[
                                                  index
                                                ]["percent"]
                                              ) +
                                              " %\n            "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-6 col-md-2 text-right bordered  tablePdMob",
                              class: {
                                "d-none d-md-block": doc.template == "no",
                                "d-block d-md-block": doc.template == "yes"
                              }
                            },
                            [
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              doc.codice == "2050D20"
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href: doc.template_link,
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("linee guida")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              doc.codice != "2050D0B" &&
                              doc.codice != "2050D20"
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href: doc.template_link,
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Modulo")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              doc.codice != "2050D0B" &&
                              doc.codice != "2050D20"
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0 white",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.precompileDocument(
                                            doc.codice,
                                            _vm.getProfile,
                                            _vm.item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("PRECOMPILATO")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              (_vm.getProfile.tipo_azienda !=
                                "Ditta Individuale" &&
                                _vm.getProfile.tipo_azienda !=
                                  "Professionista iscritto ad albi" &&
                                doc.codice == "2050D0B")
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href: doc.template_link,
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Istruzioni")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              ((_vm.getProfile.tipo_azienda ==
                                "Ditta Individuale" ||
                                _vm.getProfile.tipo_azienda ==
                                  "Professionista iscritto ad albi") &&
                                doc.codice == "2050D0B")
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href:
                                          "https://storage.googleapis.com/stage_novatag/ecobonus/2050D0Bd.vt.pdf",
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Istruzioni")]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: " col-md-1 bordered tablePdMob",
                              class: {
                                "col-12 center": doc.template == "no",
                                "col-6": doc.template == "yes"
                              }
                            },
                            [
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.item.status == 1 &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("div", { staticClass: "front-image2" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: doc.mandatory == "yes",
                                            size: 10240,
                                            ext: ["jpeg", "jpg", "png", "pdf"],
                                            mimes: [
                                              "image/jpeg",
                                              "image/jpg",
                                              "image/png",
                                              "application/pdf"
                                            ]
                                          },
                                          expression:
                                            "{required: doc.mandatory == 'yes',size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                                        }
                                      ],
                                      ref: "fileInput" + index,
                                      refInFor: true,
                                      staticClass:
                                        "btn btn-primary btn-xl btnRed",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "fileInput" + index
                                        ),
                                        valid: !!_vm.invoiceFront,
                                        helper: !!_vm.invoiceFrontBucket
                                      },
                                      attrs: {
                                        type: "file",
                                        name: "fileInput" + index,
                                        id: "fileInput" + index,
                                        "data-vv-as": doc.name
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.uploadFile(
                                            index,
                                            _vm.item.code,
                                            doc.name,
                                            doc.codice
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "highlight" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "bar" }),
                                    _vm._v(" "),
                                    _vm._m(26, true)
                                  ])
                                : (_vm.uploadFrontPercentage[index][
                                    "completed"
                                  ] &&
                                    _vm.item.status == 1 &&
                                    _vm.item.hasErrors == "no") ||
                                  (_vm.item.status == 1 &&
                                    _vm.uploadFrontPercentage[index][
                                      "hasError"
                                    ] == "yes")
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-primary btn-xl",
                                      attrs: {
                                        to: {
                                          name: "editDocument",
                                          params: {
                                            doc: doc,
                                            dbdoc:
                                              _vm.uploadFrontPercentage[index],
                                            item: _vm.item,
                                            docIndex: index
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Modifica\n          "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-4 col-md-1 bordered tablePdMob"
                            },
                            [
                              _vm.uploadFrontPercentage[index]["countImages"]
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary btn-xl",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.show(index)
                                        }
                                      }
                                    },
                                    [_vm._v("Visualizza")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "viewer",
                                {
                                  ref: "viewer" + index,
                                  refInFor: true,
                                  staticClass: "imagesViewer clearfix widthFull"
                                },
                                [
                                  _vm._l(
                                    _vm.uploadFrontPercentage[index]["images"],
                                    function(image, key) {
                                      return [
                                        image
                                          .substring(
                                            image.lastIndexOf(".") + 1,
                                            image.length
                                          )
                                          .toLowerCase() != "pdf"
                                          ? _c("img", {
                                              key: key,
                                              staticClass: "img-fluid",
                                              attrs: { src: image }
                                            })
                                          : _c(
                                              "a",
                                              {
                                                staticClass: "pdfViewer",
                                                attrs: {
                                                  href: image,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  key: key,
                                                  staticClass: "img-fluid",
                                                  attrs: {
                                                    src: require("../../assets/images/pdf.png")
                                                  }
                                                })
                                              ]
                                            )
                                      ]
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-1 text-center bordered tablePdMob"
                            },
                            [
                              _vm._l(
                                _vm.uploadFrontPercentage[index]["images"],
                                function(img) {
                                  return [
                                    img
                                      .substring(
                                        img.lastIndexOf(".") + 1,
                                        img.length
                                      )
                                      .toLowerCase() != "pdf"
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "docThumb",
                                            attrs: {
                                              href: img,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "file-alt" }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "a",
                                          {
                                            staticClass: "docThumb relative",
                                            attrs: {
                                              href: img,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "file-pdf" }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "small",
                                              { staticClass: "littlePdf" },
                                              [_vm._v("PDF")]
                                            )
                                          ],
                                          1
                                        )
                                  ]
                                }
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-1 center bordered tablePdMob"
                            },
                            [
                              _vm.uploadFrontPercentage[index]["countImages"] &&
                              !_vm.uploadFrontPercentage[index]["completed"]
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-green btn-xl",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.closeDocumentBlock(
                                            index,
                                            _vm.item.code,
                                            doc.name,
                                            doc.codice
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Concludi")]
                                  )
                                : _vm.uploadFrontPercentage[index]["completed"]
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "check" }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                ((_vm.item.dl != "old" && _vm.item.flow == "poste") ||
                  _vm.item.flow == "cdp" ||
                  _vm.item.flow == "general" ||
                  _vm.item.flow == "agileenergy" ||
                  _vm.item.flow == "mbfacta" ||
                  _vm.item.flow == "mbfacta_recovery") &&
                _vm.item.enea_request == "0"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "row justify-content-center vaillantCont pt-2 pb-2"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "col-md-12 bordered center tablePdMob"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row justify-content-center  align-items-center"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-md-1 bordered center tablePdMob "
                                  },
                                  [
                                    _vm.item.enea_cpid
                                      ? [
                                          _vm.item.enea_cpid
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull maxBomTr",
                                                attrs: {
                                                  src: require("../../assets/images/traficLight_green.png")
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      : [
                                          _c("img", {
                                            staticClass:
                                              "img-fluid widthFull maxBomTr",
                                            attrs: {
                                              src: require("../../assets/images/traficLight_red.png")
                                            }
                                          })
                                        ]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-5 mb-3" }, [
                                  _c(
                                    "h5",
                                    {
                                      staticClass:
                                        "widthFull black mt-0 pt-0 pb-0 mb-0 docTitleMob pl-md-3 text-left"
                                    },
                                    [
                                      _vm.item.bonus != "Bonus Casa 50%"
                                        ? _c("font-awesome-icon", {
                                            staticClass: "mandatoryDoc",
                                            attrs: {
                                              icon: "star-of-life",
                                              size: "xs"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                  Inserisci codice CPID della Pratica ENEA\n                "
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-5 mb-3 text-left" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "group pt-0 mt-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.enea_cpid,
                                              expression: "enea_cpid"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required:
                                                  _vm.item.bonus !=
                                                  "Bonus Casa 50%"
                                                    ? true
                                                    : false,
                                                max: 30,
                                                min: 28,
                                                regex:
                                                  "[0-9]*[0-9][0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9][A-Z]-[A-Z]*"
                                              },
                                              expression:
                                                "{required: item.bonus != 'Bonus Casa 50%' ? true : false, max: 30, min: 28, regex: '[0-9]*[0-9][0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9][A-Z]-[A-Z]*'}"
                                            }
                                          ],
                                          staticClass: "form-control pb-0 mb-0",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "enea_cpid"
                                            ),
                                            valid: !!_vm.enea_cpid,
                                            disabled: _vm.item.enea_cpid
                                          },
                                          attrs: {
                                            type: "text",
                                            disabled: _vm.item.enea_cpid,
                                            id: "enea_cpid",
                                            name: "enea_cpid",
                                            "data-vv-as": "CPID"
                                          },
                                          domProps: { value: _vm.enea_cpid },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.enea_cpid =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel ",
                                            staticStyle: {
                                              color: "black !important",
                                              top: "0px",
                                              left: "5px"
                                            },
                                            attrs: { for: "name" }
                                          },
                                          [_vm._v("CPID *")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("enea_cpid")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "enea_cpid"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-1 mb-3 text-center" },
                                  [
                                    !_vm.item.enea_cpid
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary btn-green btn-xl",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                return _vm.saveCpid()
                                              }
                                            }
                                          },
                                          [_vm._v("Concludi")]
                                        )
                                      : _vm.item.enea_cpid
                                      ? _c("font-awesome-icon", {
                                          attrs: { icon: "check" }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                (_vm.item.aditional_enea_data == null ||
                  _vm.item.aditional_enea_data == "") &&
                _vm.item.enea_request == "1"
                  ? _c("div", { staticClass: "col-md-12 center mb-4" }, [
                      _c(
                        "h5",
                        { staticClass: "Regular text-center h0 widthFull " },
                        [
                          _vm._m(27),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass: "btn btn-primary m-2 btn-sm",
                              attrs: {
                                to: {
                                  name: "complateEneaData",
                                  params: { item: _vm.item }
                                }
                              }
                            },
                            [_vm._v("\n            Inserisci Dati\n          ")]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.status == 1
                  ? _c("div", { staticClass: "row justify-content-center" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-12 text-right" },
                        [
                          !_vm.preSend
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary btnRed",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.preSendPracticeToKPMG()
                                    }
                                  }
                                },
                                [_vm._v("Avanti")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.preSend
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary btnRed",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.sendPracticeToKPMG()
                                    }
                                  }
                                },
                                [_vm._v("Procedi")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          2 == 3
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "widthFull requiredCont p-4 mt-4 text-left"
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      "Ti informiamo che è in programma un aggiornamento informatico da parte del nostro partner KPMG che migliorerà ulteriormente la tua esperienza utente sulla piattaforma"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.brand == "CHEBONUS"
                                    ? _c("b", { staticClass: "green" }, [
                                        _vm._v("Vaillant CheBonus")
                                      ])
                                    : _c("b", { staticClass: "red" }, [
                                        _vm._v(
                                          "Hermann Saunier Duval HappyBonus"
                                        )
                                      ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(
                                    "Ci scusiamo per l'eventuale disagio, con l'obiettivo di migliorare sempre di più la tua soddisfazione ed esperienza sulla piattaforma\n            "
                                  ),
                                  _vm.brand == "CHEBONUS"
                                    ? _c("b", { staticClass: "green" }, [
                                        _vm._v("Vaillant CheBonus")
                                      ])
                                    : _c("b", { staticClass: "red" }, [
                                        _vm._v(
                                          "Hermann Saunier Duval HappyBonus"
                                        )
                                      ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(
                                    "Per procedere all'inoltro delle pratiche ti suggeriamo di riprovare a partire dalle ore 18:00 del 08/11/2021.\n\n          "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center mb-3 text-center" }, [
      _c("h4", { staticClass: "Regular text-center h0 widthFull " }, [
        _c("b", [
          _vm._v(
            "Avvertenza per Decreto Legge dell’11 Novembre 2021 n. 157 relativo al contrasto alle frodi  "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "black mt-0 text-center widthFull " })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-12 center mb-0 vaillantCont text-left" },
      [
        _c("h4", { staticClass: "Regular text-center h0 widthFull " }, [
          _c("b", [
            _vm._v(
              " Per procedere con la tua pratica scegli il riquadro che è idoneo alla tua documentazione"
            )
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center mb-3 text-center" }, [
      _c("h4", { staticClass: "Regular text-center h0 widthFull " }, [
        _c("b", [
          _vm._v(
            "Avvertenza per Decreto Legge dell’11 Novembre 2021 n. 157 relativo al contrasto alle frodi  "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "black mt-0 text-center widthFull " })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-12 center mb-0 vaillantCont text-left" },
      [
        _c(
          "h4",
          { staticClass: "Regular text-center h0 widthFull uppercase" },
          [_c("b", [_vm._v(" Integrazione ")])]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v(" Visto di conformità (IVA Esclusa) ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-0 red" }, [_vm._v(" Sconto ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-4" }, [_vm._v(" IVA 22% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 borderTopBlack text-left" }, [
      _c("h5", { staticClass: " text-right mb-4" }, [
        _vm._v(
          "\n                        TOTALE (IVA inclusa)\n                      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "center  mb-3 mt-0 pt-0" }, [
      _c("b", [_vm._v("Paga con")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 center mb-3 text-left" }, [
      _c("h4", { staticClass: "Regular text-left h0 widthFull " }, [
        _c("b", [
          _vm._v(
            " Per completare la tua pratica, paga il servizio con una Carta, PayPal o Bonifico Bancario (SOFORT) "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "black mt-0 text-left widthFull " }, [
        _vm._v(
          "\n          Il prezzo è riferito ad una pratica. A pagamento avvenuto potrai caricare i documenti richiesti e completare la pratica.\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v(" Prezzo Servizio/Pratica (IVA Esclusa) ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v(" Visto conformità (IVA Esclusa) ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-0 red" }, [_vm._v(" Sconto ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-4" }, [_vm._v(" IVA 22% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left borderTopBlack" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v(
          "Prezzo Servizio di redazione e invio pratica ENEA (IVA Esclusa) "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-4" }, [_vm._v(" IVA 22% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left borderTopBlack" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v(' Prezzo Servizio "Visura Catastale" (IVA Esclusa) ')
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-4" }, [_vm._v(" IVA 22% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 borderTopBlack text-left" }, [
      _c("h5", { staticClass: " text-right mb-4" }, [
        _vm._v("\n                    TOTALE (IVA inclusa)\n                  ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "center  mb-3 mt-0 pt-3" }, [
      _c("b", [_vm._v("Paga con")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "Regular text-left h0 widthFull " }, [
      _c("b", [_vm._v(" Gestione Documenti ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-md-1 bordered text-center tablePdMob" },
      [_c("small", [_vm._v("Stato ")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-md-1 text-center bordered tablePdMob" },
      [_c("small", [_vm._v("Informazioni")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-md-3 center bordered tablePdMob" },
      [
        _c("small", [
          _vm._v("Carica/modifica Documento\n              "),
          _c("br"),
          _vm._v("(solo formati: JPG,PNG,PDF)\n            ")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-md-1 text-center bordered tablePdMob" },
      [_c("small", [_vm._v("File Documento")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [
      _c("b", [
        _vm._v(
          "Per le Pratiche con “data fattura” antecedente al 4 aprile potrà essere caricato un documento “blank” vuoto."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "niceInputLabel2 labelFileInput",
        attrs: { for: "invoiceFront" }
      },
      [_c("span", { staticClass: "smallText center white" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _c("span", { staticClass: "yellow" }, [_vm._v("Attenzione!")]),
      _vm._v(
        " Per redigere e inviare la Pratica ENEA abbiamo necessità di ulteriori informazioni "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38471c95", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38471c95","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadDocuments/index.vue
// module id = null
// module chunks = 